<ion-item class="empty-widget">

  <ion-label class="ion-text-wrap">
    <div class="title">{{ title }}</div>
  </ion-label>

</ion-item>
